
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/stake",
      function () {
        return require("private-next-pages/[lang]/stake.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/stake"])
      });
    }
  